import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <div className="footer-container">
            <a
                className="footer-link"
                href="#"
                rel="noreferrer"
            >
                Nothing will work unless you do!
            </a>
        </div>
    );
};

export default Footer;
